(function(){
  function Z(){
    var S={
      hero:document.getElementById('secHero'),
      choice:document.getElementById('secChoice'),
      qt:document.getElementById('secQuizThe'),
      qa:document.getElementById('secQuizAyur'),
      qm:document.getElementById('secQuizMatcha'),
      load:document.getElementById('secLoad'),
      gate:document.getElementById('secGate'),
      res:document.getElementById('secRes')
    };

    var pF=document.getElementById('pFill');
    var path=null;
    var sT=1;
    var sA=1;
    var sM=1;

    var EJS_SERVICE='service_uql30ws';
    var EJS_TEMPLATE='template_78movoo';
    var EJS_KEY='c3H8NqpgtVK-rk9Kd';

    function go(el,offset){
      if(!el) return;
      var top=el.getBoundingClientRect().top+(window.pageYOffset||document.documentElement.scrollTop)-(offset||40);
      window.scrollTo({top:top,behavior:'smooth'});
    }

    function pr(c,t){
      var p=t?Math.round((c/t)*100):0;
      if(pF) pF.style.width=p+'%';
    }

    function sh(k){
      if(S.hero) S.hero.classList.toggle('Q-hide',k!=='choice');
      if(S.choice) S.choice.classList.toggle('Q-hide',k!=='choice');
      if(S.qt) S.qt.classList.toggle('Q-hide',k!=='qt');
      if(S.qa) S.qa.classList.toggle('Q-hide',k!=='qa');
      if(S.qm) S.qm.classList.toggle('Q-hide',k!=='qm');
      if(S.load) S.load.classList.toggle('Q-hide',k!=='load');
      if(S.gate) S.gate.classList.toggle('Q-hide',k!=='gate');
      if(S.res) S.res.classList.toggle('Q-hide',k!=='res');
    }

    function ss(sel,n){
      document.querySelectorAll(sel).forEach(function(e){
        e.classList.toggle('Q-hide',e.getAttribute('data-s')!==String(n));
      });
    }

    function vl(sel,n){
      var c=document.querySelector(sel+'[data-s="'+n+'"]');
      if(!c) return false;
      return !!c.querySelector('input[type="radio"]:checked');
    }

    document.querySelectorAll('.Q-o').forEach(function(o){
      o.addEventListener('click',function(){
        var p=this.closest('.Q-opts');
        if(!p) return;
        p.querySelectorAll('.Q-o').forEach(function(x){x.classList.remove('Q-sel');});
        this.classList.add('Q-sel');
        var r=this.querySelector('input[type="radio"]');
        if(r) r.checked=true;
      });
    });

    function startPath(nextPath){
      path=nextPath;
      if(path==='the'){
        sT=1;sh('qt');ss('.qs',1);pr(1,10);
        setTimeout(function(){go(S.qt,20);},120);
      }else if(path==='ayur'){
        sA=1;sh('qa');ss('.qa',1);pr(1,12);
        setTimeout(function(){go(S.qa,20);},120);
      }else if(path==='matcha'){
        sM=1;sh('qm');ss('.qm',1);pr(1,6);
        setTimeout(function(){go(S.qm,20);},120);
      }
    }

    var D=[
  {n:"Gyokuro Kusanagi – Ombre d'Uji",u:"https://www.the-ology.fr/products/the-vert-gyokuro-ombre-uji-100g",d:"Chef-d'œuvre des thés d'ombre, umami intense.",g:["vert_japonais","japonais"]},
  {n:"Sencha Bio Shizuoka – Mont Fuji",u:"https://www.the-ology.fr/products/the-vert-sencha-bio-shizuoka-mont-fuji-100g",d:"Cultivé près du Mont Fuji, liqueur iodée et végétale.",g:["vert_japonais","japonais"]},
  {n:"Sencha Mizuki Bio – Kagoshima",u:"https://www.the-ology.fr/products/the-vert-sencha-mizuki-bio-kagoshima-100g",d:"Umami intense, notes d'algues nori.",g:["vert_japonais","japonais"]},
  {n:"Bancha Japonais",u:"https://www.the-ology.fr/products/the-vert-bancha-japonais-faible-cafeine-100g",d:"Thé quotidien japonais, faible en théine.",g:["vert_japonais","japonais"]},
  {n:"Hojicha Kukicha Bio – Torréfié",u:"https://www.the-ology.fr/products/the-vert-hojicha-kukicha-bio-tiges-torrefiees-100g",d:"Notes de caramel et noisette grillée, très faible théine.",g:["vert_japonais","japonais"]},
  {n:"Genmaicha Japonais",u:"https://www.the-ology.fr/products/the-vert-genmaicha-japonais-bancha-riz-grille-100g",d:"Alliance de bancha et riz torréfié, notes toastées.",g:["vert_japonais","japonais"]},
  {n:"Hinokuni Aka – Kumamoto",u:"https://www.the-ology.fr/products/the-oolong-japonais-hinokuni-aka-kumamoto-160g",d:"Oolong japonais vieilli à froid, liqueur boisée et profonde.",g:["vert_japonais","japonais"]},
  {n:"Kyobancha Torréfié de Kyoto",u:"https://www.the-ology.fr/products/the-vert-kyobancha-torrefie-kyoto-sans-theine-200g",d:"Thé vert rustique torréfié, sans théine.",g:["vert_japonais","japonais"]},
  {n:"Kamairicha Harubancha – Nara",u:"https://www.the-ology.fr/products/kamairicha-harubancha-rare-japon",d:"Thé vert torréfié à la poêle, séché au soleil, très rare.",g:["vert_japonais","japonais"]},
  {n:"Houjicha d'Uji Premium",u:"https://www.the-ology.fr/products/houjicha-uji-premium-100g",d:"Notes de noisette grillée et caramel, faible en caféine.",g:["vert_japonais","japonais"]},
  {n:"Xinyang Maojian 2026 – Henan",u:"https://www.the-ology.fr/products/the-vert-chine-xinyang-maojian-2026-printemps-100g",d:"Primeur printanier du Henan, liqueur végétale et florale.",g:["vert_chinois"]},
  {n:"Ocean Green Needle – Hubei",u:"https://www.the-ology.fr/products/the-vert-ocean-green-needle-hubei-100g",d:"Grand cru du Hubei, liqueur douce et umami délicat.",g:["vert_chinois"]},
  {n:"Mao Feng Bio – Zhejiang",u:"https://www.the-ology.fr/products/the-vert-mao-feng-bio-zhejiang-100g",d:"Pointe duveteuse du Zhejiang, liqueur miellée.",g:["vert_chinois"]},
  {n:"Gunpowder Bio – Hunan",u:"https://www.the-ology.fr/products/the-vert-gunpowder-bio-hunan-100g",d:"Perles roulées à la main, profil végétal toasté.",g:["vert_chinois"]},
  {n:"Amour de Cerise Bio",u:"https://www.the-ology.fr/products/the-vert-bio-cerise-griotte-amour-de-cerise-100g",d:"Sencha bio aux fruits rouges, liqueur fruitée.",g:["vert_chinois"]},
  {n:"Royal – Papaye, Rose & Pivoine",u:"https://www.the-ology.fr/products/the-vert-royal-papaye-rose-pivoine-100g",d:"Évasion florale et fruitée, Sencha exotique.",g:["vert_chinois"]},
  {n:"Sencha Citron Bio",u:"https://www.the-ology.fr/products/the-vert-sencha-citron-bio-citronnelle-100g",d:"Vivacité citronnée, infusion digestive.",g:["vert_chinois"]},
  {n:"Ciel Bleu – Sencha Floral & Mauve",u:"https://www.the-ology.fr/products/the-vert-ciel-bleu-sencha-floral-mauve-100g",d:"Finesse végétale sublimée par la mauve.",g:["vert_chinois"]},
  {n:"Huit Secrets d'Extrême-Orient",u:"https://www.the-ology.fr/products/the-vert-huit-secrets-extreme-orient-100g",d:"Assemblage de 5 thés, mangue, rose et goji.",g:["vert_chinois"]},
  {n:"Tie Guan Yin – Déesse de Fer",u:"https://www.the-ology.fr/products/the-oolong-tie-guan-yin-floral-anxi-100g",d:"Oolong d'Anxi, notes d'orchidée et fruits blancs.",g:["oolong"]},
  {n:"Oolong de Formose – Taiwan",u:"https://www.the-ology.fr/products/the-oolong-formose-taiwan-100g",d:"Grand classique de Taiwan, liqueur ambrée et fruitée.",g:["oolong"]},
  {n:"Red Royal Pearl – Taiwan",u:"https://www.the-ology.fr/products/the-oolong-red-royal-pearl-taiwan-100g",d:"Red Oolong oxydé à 80%, notes de fruits mûrs et caramel.",g:["oolong"]},
  {n:"Oolong au Lait – Chine",u:"https://www.the-ology.fr/products/the-oolong-lait-cremeux-chine-100g",d:"Texture veloutée, notes lactées et florales.",g:["oolong"]},
  {n:"Bai Hao Yin Zhen – Aiguilles d'Argent",u:"https://www.the-ology.fr/products/the-blanc-bai-hao-yin-zhen-aiguilles-argent-fujian-100g",d:"Thé blanc de spécialité, liqueur florale et soyeuse.",g:["blanc"]},
  {n:"White Monkey Pekoe – Fujian",u:"https://www.the-ology.fr/products/the-blanc-white-monkey-pekoe-fujian-100g",d:"Thé blanc rare des monts Taimu, texture veloutée.",g:["blanc"]},
  {n:"Pai Mu Tan Bio – Pivoine Blanche",u:"https://www.the-ology.fr/products/the-blanc-pai-mu-tan-pivoine-blanche-bio-100g",d:"Grand cru du Fujian, liqueur dorée et florale.",g:["blanc"]},
  {n:"Premier Amour – Jasmin & Framboise",u:"https://www.the-ology.fr/products/the-blanc-premier-amour-jasmin-framboise-100g",d:"Thé blanc délicat, alliance florale calme et lisible.",g:["blanc"]},
  {n:"Juliette – Rose & Framboise",u:"https://www.the-ology.fr/products/the-blanc-juliette-rose-framboise-100g",d:"Mélange floral doux, idéal en fin de journée.",g:["blanc"]},
  {n:"Huang Ya Bio – Sichuan",u:"https://www.the-ology.fr/products/the-jaune-huang-ya-bio-sichuan-100g",d:"Trésor historique du Sichuan, liqueur dorée veloutée.",g:["jaune"]},
  {n:"Assam TGFOP1 Mahaluxmi",u:"https://www.the-ology.fr/products/the-noir-assam-tgfop1-mahaluxmi-feuilles-entieres-100g",d:"Feuilles entières et bourgeons dorés, liqueur maltée.",g:["noir"]},
  {n:"Assam FBOP Moran",u:"https://www.the-ology.fr/products/the-noir-assam-fbop-moran-broken-100g",d:"Malt profond, idéal pour petit-déjeuner anglais.",g:["noir"]},
  {n:"Assam CTC BOP Borsillah",u:"https://www.the-ology.fr/products/the-noir-assam-ctc-bop-borsillah-100g",d:"Thé CTC puissant et malté, idéal pour le réveil.",g:["noir"]},
  {n:"Abricot Tournesol",u:"https://www.the-ology.fr/products/the-noir-abricot-tournesol-100g",d:"Liqueur solaire, notes fruitées et florales.",g:["noir"]},
  {n:"Truffle Praline – Chocolat Blanc & Rose",u:"https://www.the-ology.fr/products/the-noir-truffle-praline-chocolat-blanc-rose-100g",d:"Confiserie fine, liqueur onctueuse et veloutée.",g:["noir"]},
  {n:"Crème de Fraise",u:"https://www.the-ology.fr/products/the-noir-creme-de-fraise-fraisier-des-bois-100g",d:"Fraise et crème, liqueur ronde et douce.",g:["noir"]},
  {n:"Argousier & Canneberge",u:"https://www.the-ology.fr/products/the-noir-argousier-canneberge-citronnelle-100g",d:"Baies vitaminées, touche de citronnelle.",g:["noir"]},
  {n:"Jus de Chai",u:"https://www.the-ology.fr/products/the-noir-jus-de-chai-epices-juicea-100g",d:"Chai indien revisité, liqueur veloutée.",g:["noir"]},
  {n:"Mûre Sauvage",u:"https://www.the-ology.fr/products/the-noir-mure-sauvage-mauve-100g",d:"Intensité fruitée et structurée.",g:["noir"]},
  {n:"Ombre Bleue – Rhubarbe & Crème",u:"https://www.the-ology.fr/products/the-noir-ombre-bleue-rhubarbe-creme-100g",d:"Composition gourmande, acidulée et élégante.",g:["noir"]},
  {n:"Des Andes Bio – Colombie",u:"https://www.the-ology.fr/products/the-noir-andes-bio-colombie-100g",d:"Altiplano colombien, liqueur maltée et fruitée.",g:["noir"]},
  {n:"Earl Grey Deluxe Orange Sanguine",u:"https://www.the-ology.fr/products/earl-grey-deluxe-orange-sanguine-mandarine-100g",d:"Bergamote, mandarine et orange sanguine.",g:["noir"]},
  {n:"Secret des Mayas – Cacao & Chocolat",u:"https://www.the-ology.fr/products/the-noir-secret-des-mayas-cacao-chocolat-100g",d:"Trois terroirs noirs, fèves de cacao.",g:["noir"]},
  {n:"Rêve Californien",u:"https://www.the-ology.fr/products/the-noir-reve-californien-citron-rose-100g",d:"Assemblage ensoleillé, acidulé et élégant.",g:["noir"]},
  {n:"Bora Bora – Ananas & Rose",u:"https://www.the-ology.fr/products/the-noir-bora-bora-ananas-rose-pivoine-100g",d:"Tropical et floral, évasion du Pacifique.",g:["noir"]},
  {n:"Mélange Oriental – Sencha & Thé Noir",u:"https://www.the-ology.fr/products/melange-oriental-the-noir-sencha-papaye",d:"Fraîcheur herbacée et structure noire, papaye.",g:["noir"]},
  {n:"Ayurveda Pur BIO",u:"https://www.the-ology.fr/products/infusion-ayurveda-pur-bio-epices-brutes-100g",d:"Frappe directe d'épices, sans théine.",g:["infusion"]},
  {n:"Ayurveda Vatawala BIO",u:"https://www.the-ology.fr/products/infusion-ayurveda-vatawala-bio-gingembre-cannelle-100g",d:"Tisane réchauffante pour Vata.",g:["infusion"]},
  {n:"Ayurveda Pitta BIO",u:"https://www.the-ology.fr/products/infusion-ayurveda-pitta-bio-menthe-reglisse-100g",d:"Rafraîchit le feu intérieur.",g:["infusion"]},
  {n:"Ayurveda Kapha BIO",u:"https://www.the-ology.fr/products/infusion-ayurveda-kapha-bio-epices-100g",d:"Stimulante et épicée.",g:["infusion"]},
  {n:"Masala Chai Bio",u:"https://www.the-ology.fr/products/infusion-masala-chai-bio-epices-100g",d:"Âme d'un véritable Chai indien, sans théine.",g:["infusion"]},
  {n:"Juicéa® Equilibre – Rooibos & Vanille",u:"https://www.the-ology.fr/products/infusion-rooibos-vanille-juicea-equilibre-100g",d:"Perles de vanille encapsulées, onctuosité garantie.",g:["infusion"]},
  {n:"Brise-glace – Hibiscus & Menthe",u:"https://www.the-ology.fr/products/infusion-brise-glace-hibiscus-menthe-100g",d:"Vivacité sans théine, hot or iced.",g:["infusion"]},
  {n:"Coucher – Camomille & Lavande",u:"https://www.the-ology.fr/products/infusion-coucher-camomille-menthe-lavande-100g",d:"Pour préparer le sommeil sereinement.",g:["infusion"]},
  {n:"Colada Rooibos – Ananas & Coco",u:"https://www.the-ology.fr/products/colada-rooibos-ananas-coco-100g",d:"Escale tropicale, 100% sans théine.",g:["infusion"]},
  {n:"Danse des Fleurs – Rose & Bleuets",u:"https://www.the-ology.fr/products/rooibos-danse-des-fleurs-rose-bleuet-100g",d:"Rooibos orné de pétales floraux.",g:["infusion"]},
  {n:"Earl Grey Rooibos – Bergamote",u:"https://www.the-ology.fr/products/earl-grey-rooibos-sans-theine-100g",d:"Classic british reinterpreted, bergamote et douceur.",g:["infusion"]},
  {n:"Porte-Bonheur – Mangue & Passion",u:"https://www.the-ology.fr/products/infusion-porte-bonheur-mangue-passion-100g",d:"Fruitée et exotique, sans théine.",g:["infusion"]},
  {n:"Minttox BIO – Menthe & Citronnelle",u:"https://www.the-ology.fr/products/infusion-bio-minttox-menthe-citronnelle-100g",d:"Multi-plantes fraîches, moringa.",g:["infusion"]},
  {n:"Captain Carrot BIO",u:"https://www.the-ology.fr/products/infusion-bio-captain-carrot-epices-100g",d:"Carotte bio, curcuma et gingembre.",g:["infusion"]},
  {n:"Trio Amazonien – Maté & Guayusa",u:"https://www.the-ology.fr/products/trio-amazonien-mate-guayusa-acai-100g",d:"Énergie végétale progressive, açaï.",g:["infusion"]},
  {n:"Maté & Eucalyptus BIO",u:"https://www.the-ology.fr/products/infusion-mate-eucalyptus-menthe-bio-100g",d:"Énergie naturelle, fraîcheur végétale.",g:["infusion"]},
  {n:"Odins Tribute – Sureau & Ananas",u:"https://www.the-ology.fr/products/infusion-odins-tribute-sureau-ananas-100g",d:"Inspiration nordique, notes florales.",g:["infusion"]},
  {n:"Honeybush Esprit d'Afrique",u:"https://www.the-ology.fr/products/infusion-honeybush-esprit-afrique-pamplemousse-100g",d:"Sud-africain, douceur miellée.",g:["infusion"]},
  {n:"Rooibos Bio Original – Cederberg",u:"https://www.the-ology.fr/products/rooibos-bio-original-cederberg-100g",d:"Notes de noisette grillée, 100% bio.",g:["infusion"]},
  {n:"Rooibos Crème de Fraise",u:"https://www.the-ology.fr/products/rooibos-creme-fraise-afrique-sud-100g",d:"Avec tranches de fraises séchées.",g:["infusion"]},
  {n:"Rooibos Bourbon Vanille",u:"https://www.the-ology.fr/products/rooibos-bourbon-vanille-afrique-sud-100g",d:"Morceaux de vanille bourbon.",g:["infusion"]},
  {n:"Orange Sanguine Rooibos",u:"https://www.the-ology.fr/products/rooibos-orange-sanguine-agrumes-100g",d:"Écorces d'agrumes et carthame.",g:["infusion"]},
  {n:"Barbade – Mangue & Fraise",u:"https://www.the-ology.fr/products/infusion-fruitee-barbade-mangue-fraise-100g",d:"Tropicale factuelle, hibiscus et papaye.",g:["infusion"]},
  {n:"Orange Sanguine – Fruits & Hibiscus",u:"https://www.the-ology.fr/products/infusion-orange-sanguine-hibiscus-100g",d:"Liqueur rubis acidulée, hot or iced.",g:["infusion"]},
  {n:"Amaretto – Pomme & Amande",u:"https://www.the-ology.fr/products/infusion-fruitee-amaretto-pomme-amande-100g",d:"Gourmande, acidulée et sans théine.",g:["infusion"]},
  {n:"Hurricane – Anis & Fenouil",u:"https://www.the-ology.fr/products/infusion-hurricane-anis-fenouil-100g",d:"Notes réglissées et florales.",g:["infusion"]},
  {n:"Équilibre BIO – Fenouil & Anis",u:"https://www.the-ology.fr/products/infusion-bio-equilibre-fenouil-anis-100g",d:"Digestif, notes douces et herbacées.",g:["infusion"]}
];

   var TG={
  1:['vert_japonais','japonais'],
  2:['vert_chinois'],
  3:['oolong','blanc','jaune'],
  4:['noir'],
  5:['infusion']
};

var P={
  1:{t:"L'Élan Végétal",s:"Thés verts japonais étuvés",x:"Votre palais recherche la vivacité et l'énergie pure. Les thés japonais étuvés — Gyokuro, Sencha, Genmaicha — correspondent à votre sensibilité pour la netteté végétale, l'umami et l'élan frais du matin."},
  2:{t:"Le Botaniste Curieux",s:"Thés verts chinois & assemblages",x:"Vous êtes attiré par des arômes végétaux plus toastés, une texture légère et une tasse claire. Les thés verts chinois — Mao Feng, Gunpowder, Sencha aromatisés — offrent la précision et la diversité que vous cherchez."},
  3:{t:"L'Esthète de l'Ombre",s:"Oolongs, Thés Blancs & Thé Jaune",x:"Vous recherchez la profondeur, la rondeur et la complexité. Les Oolongs de Formose, les Aiguilles d'Argent du Fujian et le rare Huang Ya du Sichuan sont votre territoire naturel."},
  4:{t:"Le Connaisseur des Noirs",s:"Thés noirs de terroir & assemblages",x:"Vous aimez les liqueurs charpentées, les notes maltées et cacaotées. Des Assam puissants aux Earl Grey gourmands, vous cherchez du caractère et de la structure dans chaque tasse."},
  5:{t:"L'Explorateur de Plantes",s:"Infusions, Rooibos & Tisanes",x:"Votre équilibre passe par les plantes, les épices et les fruits. Du Rooibos sud-africain au Maté amazonien, des Ayurveda aux infusions fruitées, vous explorez un monde sans théine riche en terroirs."}
};

    var MP={
      terroir:{t:"L'Esthète du Terroir",s:"Matchas de cépage pur et haute précision",x:"Vous recherchez un matcha de dégustation, nuancé, avec une vraie lecture de terroir. Votre profil correspond aux matchas de cépage pur, orientés umami, finesse végétale et longueur en bouche.",picks:[
        {n:"Matcha Bio Sui – Pur Cépage Saemidori Bio",u:"https://www.the-ology.fr/products/matcha-sui-saemidori-bio-kagoshima",d:"Saemidori bio de Kagoshima, robe éclatante, liqueur sans amertume."},
        {n:"Matcha Bio Mitsu – Pur Cépage Okumidori Bio",u:"https://www.the-ology.fr/products/matcha-mitsu-okumidori-bio-kagoshima",d:"Okumidori bio, texture veloutée, longue finale florale."},
        {n:"Matcha Bio Akatsuki – Pur Cépage Yabukita Bio",u:"https://www.the-ology.fr/products/matcha-akatsuki-yabukita-bio-wazuka",d:"Yabukita bio de Wazuka, plus minéral et structuré."}
      ]},
      rituel:{t:"Le Gardien du Rituel",s:"Matcha d'équilibre pour une préparation traditionnelle",x:"Vous cherchez l'harmonie, la régularité et un matcha juste, pensé pour le chasen et le moment de préparation.",picks:[
        {n:"Matcha Cérémoniel d'Uji – Moulu en France sur Meule – 20g",u:"https://www.the-ology.fr/products/matcha-ceremoniel-uji-moulu-france-20g",d:"Issu d'Uji, moulu sur meule en France, fraîcheur maximale."}
      ]},
      gourmand:{t:"Le Créateur Gourmand",s:"Matchas culinaires pour latte, pâtisserie et usage intensif",x:"Vous utilisez le matcha comme matière vivante en cuisine ou en latte. Votre profil appelle un matcha plus franc, capable de tenir face au lait et aux préparations gourmandes.",picks:[
        {n:"Midori™ Culinary Matcha – 20g",u:"https://www.the-ology.fr/products/midori-culinary-matcha-20g",d:"Format découverte idéal pour latte, smoothie et recettes."}
      ]}
    };

    var AP={
      vata:{t:"Vata Pur",x:"Type Vata, dominé par Air et Éther. Votre équilibre se nourrit de chaleur, de rythme et de réconfort.",picks:[
        {n:"Ayurveda Vatawala BIO",u:"https://www.the-ology.fr/products/infusion-ayurveda-vatawala-bio-gingembre-cannelle-100g",d:"Réchauffante pour ancrer Vata."}
      ]},
      pitta:{t:"Pitta Pur",x:"Dominé par le Feu. Votre équilibre se joue dans la fraîcheur, l'apaisement et la modération.",picks:[
        {n:"Ayurveda Pitta BIO",u:"https://www.the-ology.fr/products/infusion-ayurveda-pitta-bio-menthe-reglisse-100g",d:"Rafraîchit le feu intérieur."}
      ]},
      kapha:{t:"Kapha Pur",x:"Terre et Eau dominent. Vous gagnez à inviter chaleur, mouvement et stimulation.",picks:[
        {n:"Ayurveda Kapha BIO",u:"https://www.the-ology.fr/products/infusion-ayurveda-kapha-bio-plantes-epices-100g",d:"Stimulante et épicée."}
      ]},
      tridosha:{t:"Sama Prakriti",x:"Constitution équilibrée entre les trois Doshas. Votre axe majeur : préserver cette harmonie fine.",picks:[
        {n:"Ayurveda Pur BIO",u:"https://www.the-ology.fr/products/infusion-ayurveda-pur-bio-100-epices-brutes-100g",d:"Équilibre pour votre constitution."}
      ]}
    };

    function renderTeaCards(items){
      var imgs=window.tojImages||{};
      return items.map(function(t){
        var parts=t.u.split('/products/');
        var handle=parts[1]||'';
        handle=handle.split('?')[0];
        try{handle=decodeURIComponent(handle);}catch(e){}
        var imgSrc=imgs[handle]||'';
        var imgHtml=imgSrc?'<img class="Q-tea-img" src="'+imgSrc+'" alt="'+t.n+'" loading="lazy">':'';
        return '<div class="Q-tea">'+imgHtml+'<div class="Q-tea-info"><span class="Q-tea-name">'+t.n+'</span><div class="Q-tea-desc">'+t.d+'</div><a href="'+t.u+'" class="Q-tea-link" target="_blank" rel="noopener noreferrer">Découvrir →</a></div></div>';
      }).join('');
    }

    function getTheProfile(){
  var sc={1:0,2:0,3:0,4:0,5:0};

  var map={
    q1:{
      energie:     {1:2,4:2},
      digestion:   {2:2,3:2},
      relaxation:  {3:2,5:2}
    },
    q2:{
      matin:       {1:2,4:2},
      'apres-midi':{2:2,3:2},
      soir:        {4:1,5:2}
    },
    q3:{
      vegetal:     {1:2,2:2},
      floral:      {3:2,5:2},
      boise:       {4:2,3:1}
    },
    q4:{
      aime:        {1:2,4:2},
      tolere:      {2:2,3:2},
      deteste:     {3:1,5:2}
    },
    q5:{
      rapide:      {4:2,5:2},
      classique:   {2:2,4:1},
      rituel:      {1:2,3:2}
    },
    q6:{
      leger:       {1:2,2:2},
      rond:        {3:2,5:2},
      charpente:   {4:2,1:1}
    },
    q7:{
      aucune:      {1:1,4:2},
      moyenne:     {2:2,3:2},
      forte:       {5:2,3:1}
    },
    q8:{
      seul:        {1:2,3:2},
      repas:       {2:2,4:2},
      douceur:     {5:2,4:1}
    },
    q9:{
      classique:   {4:2,5:1},
      equilibre:   {2:1,5:2},
      aventure:    {1:2,3:2}
    },
    q10:{
      vert:        {1:2,2:2},
      oxyg:        {3:2,4:1},
      sombre:      {4:2,5:2}
    }
  };

  document.querySelectorAll('#formThe input[type="radio"]:checked').forEach(function(i){
    var q=i.name;
    var v=i.value;
    if(map[q]&&map[q][v]){
      Object.keys(map[q][v]).forEach(function(p){
        sc[parseInt(p)]+=(map[q][v][p]||0);
      });
    }
  });

  var top=1;
  [1,2,3,4,5].forEach(function(p){
    if(sc[p]>sc[top]) top=p;
  });

  var pd=P[top];
  var tags=TG[top]||[];
  var m=D.filter(function(t){return t.g.some(function(g){return tags.indexOf(g)!==-1;});});
  if(m.length===0) m=D.slice(0,3);

  for(var i=m.length-1;i>0;i--){
    var j=Math.floor(Math.random()*(i+1));
    var tmp=m[i];m[i]=m[j];m[j]=tmp;
  }

  return {cN:'Chemin du thé',pT:pd.t,pS:pd.s,pX:pd.x,rH:renderTeaCards(m.slice(0,3))};
}

    function getAyurProfile(){
      var counts={vata:0,pitta:0,kapha:0};
      document.querySelectorAll('#formAyur input[type="radio"]:checked').forEach(function(i){
        if(counts[i.value]!==undefined) counts[i.value]++;
      });
      var top='vata';
      if(counts.pitta>counts[top]) top='pitta';
      if(counts.kapha>counts[top]) top='kapha';
      var total=counts.vata+counts.pitta+counts.kapha;
      var profile=(total>0&&Math.abs(counts.vata-counts.pitta)<=1&&Math.abs(counts.pitta-counts.kapha)<=1&&Math.abs(counts.vata-counts.kapha)<=1)?'tridosha':top;
      var ap=AP[profile]||AP.tridosha;
      return {cN:'Chemin ayurvédique',pT:ap.t,pS:'',pX:ap.x,rH:renderTeaCards(ap.picks)};
    }

    function getMatchaProfile(){
      var m1=(document.querySelector('input[name="m1"]:checked')||{}).value||'';
      var m2=(document.querySelector('input[name="m2"]:checked')||{}).value||'';
      var m3=(document.querySelector('input[name="m3"]:checked')||{}).value||'';
      var m4=(document.querySelector('input[name="m4"]:checked')||{}).value||'';
      var m5=(document.querySelector('input[name="m5"]:checked')||{}).value||'';
      var m6=(document.querySelector('input[name="m6"]:checked')||{}).value||'';
      var profile='rituel';
      if(m1==='cuisine'||m1==='latte'||m4==='intensif'||m6==='mousseur'||m6==='cuisine'){
        profile='gourmand';
      }else if(m1==='pur'&&(m2==='puriste'||m5==='terroir'||m3==='umami'||m6==='chasen')){
        profile='terroir';
      }
      var mp=MP[profile];
      return {cN:'Chemin du matcha',pT:mp.t,pS:mp.s,pX:mp.x,rH:renderTeaCards(mp.picks)};
    }

    function showResult(result,prenom){
      if(document.getElementById('rPath')) document.getElementById('rPath').textContent=result.cN;
      if(document.getElementById('rSub')) document.getElementById('rSub').textContent=result.pS;
      if(document.getElementById('rTitle')) document.getElementById('rTitle').innerHTML='<span class="rTitle-pre">Profil de</span> '+prenom+'<br><em>'+result.pT+'</em>';
      if(document.getElementById('rText')) document.getElementById('rText').innerHTML='<p>'+result.pX+'</p>';
      if(document.getElementById('rTeas')) document.getElementById('rTeas').innerHTML=result.rH;
      sh('res');
      go(S.res,20);
    }

    function finishQuiz(){
      sh('load');pr(100,100);go(S.load,20);
      setTimeout(function(){sh('gate');go(S.gate,20);},1400);
    }

    var btnThe=document.getElementById('btnThe');
    var btnAyur=document.getElementById('btnAyur');
    var btnMatcha=document.getElementById('btnMatcha');
    var btnDecouvrir=document.getElementById('btnDecouvrir');

    if(btnThe) btnThe.addEventListener('click',function(e){e.preventDefault();startPath('the');});
    if(btnAyur) btnAyur.addEventListener('click',function(e){e.preventDefault();startPath('ayur');});
    if(btnMatcha) btnMatcha.addEventListener('click',function(e){e.preventDefault();startPath('matcha');});
    if(btnDecouvrir) btnDecouvrir.addEventListener('click',function(e){e.preventDefault();go(S.choice,20);});

    var nextThe=document.getElementById('nextThe');
    if(nextThe){
      nextThe.addEventListener('click',function(e){
        e.preventDefault();
        var err=document.getElementById('errThe');
        if(!vl('.qs',sT)){if(err) err.style.display='block';return;}
        if(err) err.style.display='none';
        if(sT<10){sT++;ss('.qs',sT);pr(sT,10);go(S.qt,20);}
        else{finishQuiz();}
      });
    }

    var nextAyur=document.getElementById('nextAyur');
    if(nextAyur){
      nextAyur.addEventListener('click',function(e){
        e.preventDefault();
        var err=document.getElementById('errAyur');
        if(!vl('.qa',sA)){if(err) err.style.display='block';return;}
        if(err) err.style.display='none';
        if(sA<12){sA++;ss('.qa',sA);pr(sA,12);go(S.qa,20);}
        else{finishQuiz();}
      });
    }

    var nextMatcha=document.getElementById('nextMatcha');
    if(nextMatcha){
      nextMatcha.addEventListener('click',function(e){
        e.preventDefault();
        var err=document.getElementById('errMatcha');
        if(!vl('.qm',sM)){if(err) err.style.display='block';return;}
        if(err) err.style.display='none';
        if(sM<6){sM++;ss('.qm',sM);pr(sM,6);go(S.qm,20);}
        else{finishQuiz();}
      });
    }

    var emailForm=document.getElementById('emailForm');
    if(emailForm){
      emailForm.addEventListener('submit',function(e){
        e.preventDefault();
        var sb=document.getElementById('subBtn');
        var ee=document.getElementById('errMail');
        if(ee) ee.style.display='none';

        var prenom=((document.getElementById('prenom')||{}).value||'').trim();
        var email=((document.getElementById('email')||{}).value||'').trim();

        if(!prenom||!email||email.indexOf('@')===-1){
          if(ee){ee.textContent='Merci de renseigner un prénom et un email valide.';ee.style.display='block';}
          return;
        }

        if(sb){sb.innerHTML='Analyse en cours...';sb.style.opacity='0.7';sb.disabled=true;}

        var result;
        if(path==='matcha') result=getMatchaProfile();
        else if(path==='the') result=getTheProfile();
        else result=getAyurProfile();

        showResult(result,prenom);

        if(sb){sb.innerHTML='Découvrir Mon Profil';sb.style.opacity='1';sb.disabled=false;}

        try{
          emailjs.send(EJS_SERVICE,EJS_TEMPLATE,{
            prenom:prenom,
            email:email,
            chemin:result.cN,
            profil:result.pT
          },EJS_KEY).catch(function(){});
        }catch(ex){}
      });
    }

    var rstBtn=document.getElementById('rstBtn');
    if(rstBtn){
      rstBtn.addEventListener('click',function(){
        sh('choice');pr(0,1);
        setTimeout(function(){go(S.hero,20);},80);
        document.querySelectorAll('input[type="radio"]').forEach(function(r){r.checked=false;});
        document.querySelectorAll('.Q-o').forEach(function(o){o.classList.remove('Q-sel');});
        if(document.getElementById('prenom')) document.getElementById('prenom').value='';
        if(document.getElementById('email')) document.getElementById('email').value='';
        if(document.getElementById('errMail')) document.getElementById('errMail').style.display='none';
        sT=1;sA=1;sM=1;path=null;
      });
    }

    sh('choice');pr(0,1);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',Z);
  else Z();
})();